export const m1l1Solution = `%lang starknet
// Short strings really are felts in disguise, and support the same basic operations
// do not modify code on this line or above

// TODO: Find the correct key to decode the string that passes the test

func decode_cipher1() -> (plaintext : felt) {
    let ciphertext = 'Another One Bites The Dust';
    // let key = 34642338947246174141841020580919298249066932857229157879292816894
    let key = 'Twinkle Twinkle Little Star' - 'Another One Bites The Dust';
    let plaintext = ciphertext + key;
    return (plaintext=plaintext);
}

// TODO: Find the correct ciphertext that passes the test

func decode_cipher2() -> (plaintext : felt) {
    // let ciphertext = 3042032262124705672547337926850636172917305208722716617195516092604696795127
    let ciphertext = ('Magic Starknet Money' - 0xc0de) / 1337;
    let plaintext = 1337 * ciphertext + 0xc0de;
    return (plaintext=plaintext);
}

// do not modify code on this line or below

@external
func test_decode_string{syscall_ptr : felt*}() {
    // The correct key should produce the corresponding plaintext
    let (decoded_string) = decode_cipher1();
    assert decoded_string = 'Twinkle Twinkle Little Star';

    // The correct ciphertext should produce corresponding plaintext
    let (decoded_string) = decode_cipher2();
    assert decoded_string = 'Magic Starknet Money';

    return ();
}`;
